import { makeAutoObservable } from "mobx"
import DataLoading from "react-sdk/DataLoading"
import Texts from "react-sdk/Texts"

import { getUrlVar } from "react-sdk/utils"
// import SoundPlayer from "react-sdk/SoundPlayer";
import Config from "react-sdk/Config"
import ScaleManager from "react-sdk/ScaleManager"

import SequencesManager from "react-sdk/haxelibs/SequencesManager"

import SoundPlayer from "react-sdk/SoundPlayer"
import Analytics from "react-sdk/Vertx/Analytics"

import PopupsManager from "react-sdk/PopupsManager"
import Dials from "./Dials"
import Minigames from "./Minigames/Minigames"
import ReaxeAPI from "./ReaxeAPI"
import SequenceScenario from "./SequenceScenario"
// import GroupMessages from "./GroupMessages"

import FtueHelper from "./FtueHelper"
import ObjectiveFile from "./Objectives/ObjectiveFile"
import Periods from "./Periods"
import SaveGame from "./SaveGame"
import SelectionPhase from "./SelectionPhase"
import Vues from "./Vues"


const VertxClient = window.gms.VertxClient

// NOTE je fais ça pour tester, ca serait bien de pouvoir générer ça en auto...
/**
 * @typedef VertxClientDef
 * @type {object}
 * @property {object} UserData
 * @property {function} UserData.getUniverse
 * @property {function} UserData.getPseudo
 * @property {function} UserData.getUserMail
 * @property {function} UserData.getUserID
 */

export const SCREENS = {
  LOADING: "LOADING",
  LOGIN: "LOGIN",
  HOME: "HOME",
  USER: "USER",
  VIDEO: "VIDEO",
  GAME: "GAME",
  TEST_MG: "TEST_MG",
  ECRAN_FINAL: "ECRAN_FINAL",
}

export const POPUPS = {
  LOADING: "LOADING",
  USER: "USER",
  LEADERBOARD: "LEADERBOARD",
  NEW_OBJECTIVE: "NEW_OBJECTIVE",
  INTRO: "INTRO",
  PERIOD: "PERIOD",
  COLLECTE: "COLLECTE",
  NOTIF: "NOTIF",
  FTUE: "FTUE",
  REPLAY_MG: "REPLAY_MG",
  LOCATION: "LOCATION",
  MINIGAME_STARS: "MINIGAME_STARS",
  NOUVEAUTES: "NOUVEAUTES",
  MENTION_LEGALES: "MENTION_LEGALES",
}

class AppState {
  debugMode = false
  fastMode = false

  test_mg_mode = false

  language = "fr"
  screen = SCREENS.LOADING

  /** @type {VertxClientDef} */
  vertxClient = null
  connected = false

  groupReferent = null

  userStars = null

  reaxe_api = null

  haxeCanvas = null

  mapVisible = true
  getMapState = null // fonction registered par la Map pour qu'on l'appelle d'ici
  loadedMapState = null // le state restauré de la map est stocké ici en attendant que la map puisse l'utiliser
  mapFtueBatimentBoundingBox = null // ceci c'est des coords de BB pour cibler les batiments avec la ftue

  nextPeriod = null // id de la prochaine periode

  fullscreen = false

  UI_visibilities = {}
  lockHud = false // HACK

  period = null
  selection = null

  lockInteraction = false

  skipIntro = false

  get userIsReferent() {
    return !!this.groupReferent
  }
  constructor() {
    this.debugMode = getUrlVar("debug") !== null
    this.fastMode = getUrlVar("fast")

    this.test_mg_mode = getUrlVar("test_mg") !== null

    this.skipIntro = getUrlVar("skipIntro") !== null

    ScaleManager.init(1920, 1080)

    // if (window.location.hostname === "rekup-r.com") {
    //   Sentry.init({
    //     dsn: "https://c52629f736d240ca963f252e2bb9da77@app.glitchtip.com/7178",
    //     tracesSampleRate: 0.01,
    //     release: import.meta.env.VITE_APP_VERSION
    //   })
    // }

    SequencesManager.variables.verbose = false
    let requiredFiles = window.CONFIG.requiredFiles;

    DataLoading.getAllFiles(window.CONFIG.requiredFiles, window.CONFIG.root)
      .then(files => {
        Config.init(files.config)

        this.reaxe_api = new ReaxeAPI()
        this.haxeCanvas = document.createElement("canvas")
        window.lime.embed(
          "backend-haxe",
          this.haxeCanvas,
          ScaleManager.w,
          ScaleManager.h,
          {
            parameters: {
              logLevel: Config.get("haxe_loglevel"),
              gameWidth: ScaleManager.w,
              gameHeight: ScaleManager.h,
              reaxe_api: this.reaxe_api.api,
            },
          }
        )

        Texts.init(files.texts, this.language)

        Vues.init(files.vues)

        this.dials = new Dials(getUrlVar("skip") !== null)

        let seqId = null

        for (let i = 0; i < files.dials.length; i++) {

          let prev = i > 0 ? files.dials[i - 1] : null
          let d = files.dials[i]
          let next = i < files.dials.length - 1 ? files.dials[i + 1] : null

          if (seqId === null || seqId !== d.SequenceID) {
            seqId = d.SequenceID
          }

          if(prev && prev.SequenceID !== d.SequenceID) prev = null // sécurité
          if(next && next.SequenceID !== d.SequenceID) next = null // sécurité

          d.Character = d.Character ?? "placeholder"
          d.rightCharacters = "petitFils"

          if (d.Character === "petitFils") {

            if (prev && next) {
              d.leftCharacters = prev.Character === next.Character ? prev.Character : "mami"
            }
            else if(!prev && next) {
              d.leftCharacters = next.Character
            }
            else {
              d.leftCharacters = "mami"
            }

          }
          else {
            d.leftCharacters = d.Character
          }
        }




        this.dials.addDialFile("Dials", files.dials)

        this.period = null
        Periods.init(files.periods)

        this.soloObjectives = new ObjectiveFile(window.CONFIG.root + window.CONFIG.requiredFiles.objectives)
        this.soloObjectives.objectives.forEach(obj => {

          obj.sourceObjective.available.addPostAction((doneFunc) => {
            this.lockInteraction = true
            // SequenceScenario.next()
            doneFunc()
          })

          obj.sourceObjective.completed.addPostAction((doneFunc) => {
            if (obj.parent && obj.children.length > 0) { // les objectifs intermédiaires
              SequenceScenario.playSequence("MainSequence", this.period.id)
            }
            doneFunc()
          })
        })

        SoundPlayer.init(files.audio)


        Minigames.init(
          window.CONFIG.root + requiredFiles.minigames,
          files
        )


        SelectionPhase.init(files.selection)

        FtueHelper.initFtueFromFile(files.ftue)


        SequenceScenario.init()
        // SequenceScenario.addFile("SequencesScenario", files.sequences_scenario);
        SequenceScenario.addFile("MainSequence", files.main_sequence)
        SequenceScenario.addFile("Past", files.past)
        SequenceScenario.addFile("Present", files.present)
        SequenceScenario.addFile("Future", files.future)
      })
      .then(() => {
        // pas besoin du charEngine comme on n'utilise que des persos animate
        window.SpeechAPI.waitCharacterEngine(false)
        //window.SpeechAPI.setLogLevel(Config.get("speechapi_loglevel"))

        return new Promise(resolve => {
          window.SpeechAPI.initCharacters(
            window.CONFIG.root + "characters.char",
            () => {
              window.SpeechAPI.loadCharacterIds(["mami", "petitFils", "papi"], () => {
                resolve()
              })
              // resolve()
            }
          )
        })
      })
      .then(() => {
        var goto = getUrlVar("goto")
        if (goto) {
          SaveGame.clearSave()
        }
      })
      .then(() => {
        if (this.test_mg_mode) {


          this.setScreen(SCREENS.TEST_MG)
          PopupsManager.open(POPUPS.REPLAY_MG)
        }
        else {
          this.setScreen(getUrlVar("goEnd") ? SCREENS.ECRAN_FINAL : SCREENS.HOME)
        }
      })

    makeAutoObservable(this, {
      vertxClient: false,
      reaxe_api: false,
      haxeCanvas: false,
      getMapState: false,
      loadedMapState: false,
    })
  }

  toggleFullscreen() {
    if (this.fullscreen) {
      document.exitFullscreen().then(() => {
        this.fullscreen = false
      })
    }
    else {
      document.documentElement.requestFullscreen().then(() => {
        this.fullscreen = true
      })
    }
  }

  showFtue() {
  }


  setScreen(id) {
    Analytics.changeScreenEvents(this.screen, id)
    this.screen = id
  }

  launchNextPeriod() {

    PopupsManager.open(POPUPS.LOADING)

    let id = this.nextPeriod
    this.nextPeriod = null

    this.reaxe_api.toHaxe("map", "ChangeAllPoiClickable", { clickable: false }, () => {
      Periods.select(id)
        .then(() => {

          if (this.period.type === "selection") {
            this.selection = SelectionPhase.get(id)
          }

          SequenceScenario.playSequence("MainSequence", id)
        })
    })
  }

  userGetStars() {
    return new Promise((resolve, reject) => {
      resolve({})
    }).catch(err => console.error(err))
  }

  userSaveStars(stars, increment = true) {
    return this.userGetStars()
  }

  onMapReady() {
    if (this.test_mg_mode) return
    this.mapVisible = true

    this.getMapState = () => {
      return this.reaxe_api.api.registeredFunctions.stateToJson()
    }
  }

  startMainScenario() {


    // quick access to specific episode
    var goto = getUrlVar("goto")
    if (goto) {
      this.nextPeriod = goto
      this.launchNextPeriod()
    }
    else {
      this.nextPeriod = "past"
      this.launchNextPeriod()
    }
  }
  
  startFutureScenario() {
      // this.dials.debugSkip = true;
      this.nextPeriod = "future"

      this.dials.debugSkip = true
      this.skipIntro = true

      this.launchNextPeriod()
  }
}



export default new AppState()
